import client from '../config/AxiosConfig';

export const UpdateWeddingCanvaConfigs = async (data) =>
  client.post(`/weddingCanvaConfigs`, data);

export const GetWeddingCanvaConfigs = async =>
  client.get(`/weddingCanvaConfigs`);